import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./newHeader.css";
import userService from "shared/services/auth/userService";

interface User {
  photoUrl: string;
  displayName: string;
  role: string;
}

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState<User | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");

  const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (searchQuery.trim() !== "") {
      navigate(`?query=${encodeURIComponent(searchQuery)}`);
    }
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const user = await userService.getMe();
        console.log(user);
        if (user) {
          setUser(user.data.data.user ?? {});
        }
      } catch (err) {}
    };

    fetchUser();
  }, [navigate]);

  const handleLogin = () => {
    navigate("/signin");
  };
  const handleLogout = async () => {
    try {
      await userService.logOut();
      localStorage.removeItem("token");
      setUser(null);
      navigate("/");
    } catch (e) {
      console.error("Error during logout:", e);
    }
  };

  return (
    <>
      <header
        className="p-sm-1 border-bottom fixed-top bg-white shadow-sm position-relative"
        style={{ zIndex: 888 }}
      >
        <div className="container">
          <div className="d-flex flex-wrap align-items-center justify-content-between">
            <button
              onClick={() => navigate("/")}
              className="d-flex align-items-center mb-2 mb-lg-0 link-body-emphasis text-decoration-none btn"
            >
              <img src="/logoe32.png" width="30" height="30" />
              <img src="/logoc32.png" width="30" height="30" />
            </button>

            {/* <ul className="nav col-12 col-lg-auto me-lg-auto mb-2 justify-content-center mb-md-0 d-flex d-md-none">
              <li className="nav-item">
                <button
                  onClick={() => navigate("/woman")}
                  className="nav-link px-2 link-secondary"
                >
                  Thời trang nữ
                </button>
              </li>
              <li className="nav-item">
                <button
                  onClick={() => navigate("/men")}
                  className="nav-link px-2 link-body-emphasis"
                >
                  Thời trang nam
                </button>
              </li>
            </ul> */}

            <ul className="nav col-lg-auto mx-auto justify-content-center mb-0 d-flex align-items-center gap-sm-5">
              <li className="nav-item">
                <button
                  onClick={() => navigate("/women")}
                  className={`nav-link p-2 fs-6 transition-all duration-300 
            ${
              location.pathname === "/women"
                ? "fw-bold underline text-primary"
                : "link-secondary hover:text-primary"
            }`}
                >
                  NỮ
                </button>
              </li>
              <li className="nav-item">
                <button
                  onClick={() => navigate("/men")}
                  className={`nav-link p-2 fs-6 transition-all duration-300 
            ${
              location.pathname === "/men"
                ? "fw-bold underline text-primary"
                : "link-body-emphasis hover:text-primary"
            }`}
                >
                  NAM
                </button>
              </li>
            </ul>

            <div className="d-flex align-items-center">
              <button
                onClick={() => navigate("/cart")}
                className="btn btn-rs"
                title="Giỏ hàng"
              >
                <i className="header-icon cart pi pi-shopping-cart d-flex align-items-center"></i>
              </button>

              <button
                onClick={() => navigate("/order")}
                className="btn btn-rs"
                title="Đơn hàng"
              >
                <i className="header-icon wish-list pi pi-inbox d-flex align-items-center"></i>
              </button>

              {user?.role === "admin" && (
                <button
                  onClick={() => navigate("/admin")}
                  className="btn btn-rs d-none d-lg-flex"
                  title="Quản lý"
                >
                  <i className="header-icon admin pi pi-shield d-flex align-items-center"></i>
                </button>
              )}

              <button
                className="btn btn-rs d-sm-none"
                type="button"
                data-bs-toggle="offcanvas"
                data-bs-target="#mobileSidebar"
                aria-controls="mobileSidebar"
              >
                <i className="header-icon pi pi-list d-flex align-items-center"></i>
              </button>

              <div className="dropdown text-end d-none d-lg-flex">
                {user ? (
                  <button
                    className="d-block link-body-emphasis text-decoration-none dropdown-toggle btn"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={user?.photoUrl}
                      alt="User Avatar"
                      width="42"
                      height="42"
                      className="rounded-circle"
                    />
                  </button>
                ) : (
                  <button onClick={handleLogin} className="btn btn-primary">
                    Đăng nhập
                  </button>
                )}

                {user && (
                  <ul className="dropdown-menu text-small">
                    {user?.role === "admin" && (
                      <li>
                        <button
                          className="dropdown-item"
                          onClick={() => navigate("/admin")}
                        >
                          Admin
                        </button>
                      </li>
                    )}
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={() => navigate("/member")}
                      >
                        Tài khoản
                      </button>
                    </li>
                    <li>
                      <hr className="dropdown-divider" />
                    </li>
                    <li>
                      <button className="dropdown-item" onClick={handleLogout}>
                        Đăng xuất
                      </button>
                    </li>
                  </ul>
                )}
              </div>
            </div>
          </div>
        </div>
      </header>

      <div
        className="offcanvas offcanvas-start custom-offcanvas"
        tabIndex={-1}
        id="mobileSidebar"
        aria-labelledby="mobileSidebarLabel"
      >
        <div className="offcanvas-header">
          <div className="d-flex gap-2 align-items-center">
            {user ? (
              <img
                src={user?.photoUrl}
                alt="User Avatar"
                width="40"
                height="40"
                className="rounded-circle"
              />
            ) : (
              <button onClick={handleLogin} className="btn btn-primary">
                Đăng nhập
              </button>
            )}
            <h6 className="offcanvas-title" id="mobileSidebarLabel">
              {user?.displayName}
            </h6>
          </div>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="nav flex-column">
            {user?.role === "admin" && (
              <li className="nav-item">
                <button
                  onClick={() => navigate("/admin")}
                  data-bs-dismiss="offcanvas"
                  className="nav-link"
                >
                  Admin
                </button>
              </li>
            )}
            <li className="nav-item">
              <button
                onClick={() => navigate("/member")}
                data-bs-dismiss="offcanvas"
                className="nav-link"
              >
                Tài khoản
              </button>
            </li>
            <li className="nav-item">
              <button
                onClick={handleLogout}
                data-bs-dismiss="offcanvas"
                className="nav-link"
              >
                Đăng xuất
              </button>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Header;
